import axios from 'axios'

const { REACT_APP_SERVER_ENV } = process.env

const backendHost = {
  'production': 'https://datagateway.fractaltecnologia.com.br',
  'staging': 'https://staging.datagateway.fractaltecnologia.com.br',
  'homolog': 'https://homolog.datagateway.fractaltecnologia.com.br',
  'development': 'https://dev-datagateway.fractaltecnologia.com.br',
  'demo': 'https://demo-datagateway.fractaltecnologia.com.br',
  'local': 'http://localhost:3000'
}

const setAPIEnv = env =>
  REACT_APP_SERVER_ENV ? backendHost[REACT_APP_SERVER_ENV] : backendHost['development']

const apiVersion = 'v1'

const instance = axios.create({
  baseURL: `${setAPIEnv()}/api/${apiVersion}`
})

export const host = backendHost

export default instance
